module.exports = __webpack_public_path__ + "static/media/53_tn.a7907971.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/53_tn.jpg
// module id = 361
// module chunks = 0